import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "../components/ui/button";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="mb-8">
          <div className="w-16 h-16 bg-maple rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-heading font-bold text-3xl">C</span>
          </div>
        </div>

        {/* 404 Message */}
        <h1 className="text-7xl font-heading font-bold text-maple mb-4">404</h1>
        <h2 className="text-2xl font-heading font-semibold text-slate-900 mb-3">
          Page Not Found
        </h2>
        <p className="text-slate-600 mb-8">
          The page you&#39;re looking for doesn&#39;t exist or has been moved.
          Let&#39;s get you back on track for your citizenship journey!
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/dashboard">
            <Button className="bg-maple hover:bg-maple-600 text-white gap-2 w-full sm:w-auto">
              <Home className="w-4 h-4" />
              Go to Dashboard
            </Button>
          </Link>
          <Button 
            variant="outline" 
            className="gap-2"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

